import styled from 'styled-components'

const PowerBIIframe = styled.iframe`
    border: 0;
`

function PowerBI({ id }: { id: string }) {
    const reportId = id.replace('powerbi:', '')
    const src = `https://app.powerbi.com/view?r=${reportId}`

    return (
        <PowerBIIframe
            title="Sample power bi Dashboard V1"
            width="100%"
            height="100%"
            src={src}
            allowFullScreen
        />
    )
}

PowerBI.isPowerBI = (id: string) => id.startsWith('powerbi:')

export default PowerBI
